// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file responses/v1/market_list_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { RateType, ShippingRateDefinition } from '../../shopify/v1/shipping_rates_pb';
import { file_shopify_v1_shipping_rates } from '../../shopify/v1/shipping_rates_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/market_list_response.proto.
 */
export const file_responses_v1_market_list_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CidyZXNwb25zZXMvdjEvbWFya2V0X2xpc3RfcmVzcG9uc2UucHJvdG8SDHJlc3BvbnNlcy52MSKsAQoTTWFya2V0U2hpcHBpbmdSYXRlcxIiCgR0eXBlGAEgASgOMhQuc2hvcGlmeS52MS5SYXRlVHlwZRI3CgtkZWZpbml0aW9ucxgCIAMoCzIiLnNob3BpZnkudjEuU2hpcHBpbmdSYXRlRGVmaW5pdGlvbhIRCgltYXJrZXRfaWQYBSABKAlKBAgDEARKBAgEEAVSCmVuZF9jdXJzb3JSDWhhc19uZXh0X3BhZ2UiegoSTWFya2V0TGlzdFJlc3BvbnNlEjkKDnNoaXBwaW5nX3JhdGVzGAEgAygLMiEucmVzcG9uc2VzLnYxLk1hcmtldFNoaXBwaW5nUmF0ZXMSEgoKZW5kX2N1cnNvchgCIAEoCRIVCg1oYXNfbmV4dF9wYWdlGAMgASgIQoIBChBjb20ucmVzcG9uc2VzLnYxQhdNYXJrZXRMaXN0UmVzcG9uc2VQcm90b1ABWgQuL3BiogIDUlhYqgIMUmVzcG9uc2VzLlYxygIMUmVzcG9uc2VzXFYx4gIYUmVzcG9uc2VzXFYxXEdQQk1ldGFkYXRh6gINUmVzcG9uc2VzOjpWMWIGcHJvdG8z',
        [file_shopify_v1_shipping_rates]
    );

/**
 * MarketShippingRates is the shipping rates of one rate type of one market, in
 * the order the market's rate types are read in. A market with shipping
 * disabled contributes none, because it has no option definitions to read.
 *
 * The definitions are the first page Shopify serves of that rate type, and the
 * page is not continuable: nothing continues it over HTTP, so a cursor of its
 * own would be a promise this API cannot keep. Paging is the market connection
 * alone, on MarketListResponse.
 *
 * @generated from message responses.v1.MarketShippingRates
 */
export type MarketShippingRates = Message<'responses.v1.MarketShippingRates'> & {
    /**
     * type is the rate type the definitions were read of. It is what tells an
     * empty entry apart from an empty entry of another type.
     *
     * @generated from field: shopify.v1.RateType type = 1;
     */
    type: RateType;

    /**
     * @generated from field: repeated shopify.v1.ShippingRateDefinition definitions = 2;
     */
    definitions: ShippingRateDefinition[];

    /**
     * market_id is the market the entry was read of, as a Shopify global id. It
     * is what tells the entries of one market apart from another's on a page
     * carrying several markets.
     *
     * @generated from field: string market_id = 5;
     */
    marketId: string;
};

/**
 * Describes the message responses.v1.MarketShippingRates.
 * Use `create(MarketShippingRatesSchema)` to create a new message.
 */
export const MarketShippingRatesSchema: GenMessage<MarketShippingRates> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_market_list_response, 0);

/**
 * MarketListResponse is the shipping rates of one page of the shop's markets,
 * as the UI reads them to map a rate onto a provider. The markets themselves
 * are not carried beyond the id each entry names: a definition is addressed by
 * its own id, and the market is only what the page was read through.
 *
 * @generated from message responses.v1.MarketListResponse
 */
export type MarketListResponse = Message<'responses.v1.MarketListResponse'> & {
    /**
     * @generated from field: repeated responses.v1.MarketShippingRates shipping_rates = 1;
     */
    shippingRates: MarketShippingRates[];

    /**
     * end_cursor is what the next page of markets is asked for with, passed back
     * as the after query parameter. Empty when the page is the last one.
     *
     * Paging is a cursor rather than the page/per_page meta the order list
     * returns, because markets come from a Shopify GraphQL connection: the shop's
     * market count is never known up front, so a page number has nothing to be
     * computed from.
     *
     * @generated from field: string end_cursor = 2;
     */
    endCursor: string;

    /**
     * has_next_page reports whether the shop holds markets after this page. It is
     * what the UI hides its next control on.
     *
     * @generated from field: bool has_next_page = 3;
     */
    hasNextPage: boolean;
};

/**
 * Describes the message responses.v1.MarketListResponse.
 * Use `create(MarketListResponseSchema)` to create a new message.
 */
export const MarketListResponseSchema: GenMessage<MarketListResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_market_list_response, 1);
